import { Component, HostBinding, Input } from '@angular/core';
import { NgClass } from '@angular/common';

import { IconComponent, IconName } from '@iss/core/icon';

@Component({
  selector: 'wo-page-mobile-nav-tab-bar-item',
  templateUrl: './page-mobile-nav-tab-bar-item.component.html',
  styleUrls: [ './page-mobile-nav-tab-bar-item.component.scss' ],
  standalone: true,
  imports: [ NgClass, IconComponent ],
})
export class PageMobileNavTabBarItemComponent {
  @Input({ required: true }) iconName!: IconName;

  @HostBinding('data-title') @Input({ required: true }) public title!: string;
}
